import { useEffect, useState } from 'react'

function Logo() {
	return (
		<div className="flex items-center gap-2">
			<svg
				width="22"
				height="22"
				viewBox="0 0 22 22"
				style={{ color: '#1c1917' }}
			>
				<path
					d="M2 17 L11 4 L20 17 Z"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeLinejoin="miter"
				/>
				<path
					d="M6 17 L11 10 L16 17"
					fill="none"
					stroke="currentColor"
					strokeWidth="1.6"
					strokeLinejoin="miter"
				/>
			</svg>
			<span
				className="ds-font-display text-[22px] leading-none tracking-tight"
				style={{ color: '#1c1917' }}
			>
				Summit
			</span>
			<span
				className="mt-1 hidden text-[10px] font-medium uppercase tracking-[0.22em] sm:inline"
				style={{ color: '#78716c' }}
			>
				Roofing & Exteriors
			</span>
		</div>
	)
}

export function DemoHeader() {
	const [scrolled, setScrolled] = useState(false)
	const [open, setOpen] = useState(false)

	useEffect(() => {
		const fn = () => setScrolled(window.scrollY > 8)
		fn()
		window.addEventListener('scroll', fn, { passive: true })
		return () => window.removeEventListener('scroll', fn)
	}, [])

	return (
		<header
			className={`fixed inset-x-0 top-0 z-40 transition-all duration-300 ${scrolled ? 'ds-nav-scrolled' : ''}`}
		>
			<div className="mx-auto flex h-[72px] max-w-[1360px] items-center justify-between px-5 md:px-10">
				<a href="#top" className="flex items-center gap-2.5">
					<Logo />
				</a>
				<nav
					className="hidden items-center gap-9 text-[13.5px] font-medium md:flex"
					style={{ color: '#292524' }}
				>
					<a href="#services" className="ds-link-underline">
						Services
					</a>
					<a href="#work" className="ds-link-underline">
						Our Work
					</a>
					<a href="#why" className="ds-link-underline">
						About
					</a>
					<a href="#reviews" className="ds-link-underline">
						Reviews
					</a>
				</nav>
				<div className="hidden items-center gap-5 md:flex">
					<a
						href="tel:+18175550199"
						className="ds-link-underline text-[13.5px] font-medium"
						style={{ color: '#292524' }}
					>
						(817) 555-0199
					</a>
					<a
						href="#estimate"
						className="ds-btn-primary rounded-sm px-5 py-2.5 text-[13.5px] font-semibold"
					>
						Free estimate
					</a>
				</div>
				<button
					aria-label="Menu"
					onClick={() => setOpen((v) => !v)}
					className="flex h-10 w-10 items-center justify-center rounded-sm md:hidden"
					style={{ color: '#1c1917' }}
				>
					<svg width="20" height="14" viewBox="0 0 20 14" fill="none">
						<path
							d={
								open
									? 'M2 2L18 12 M18 2L2 12'
									: 'M0 1H20 M0 7H20 M0 13H20'
							}
							stroke="currentColor"
							strokeWidth="1.6"
							strokeLinecap="round"
						/>
					</svg>
				</button>
			</div>
			{open ? (
				<div
					className="border-t border-[#1c1917]/10 backdrop-blur-md md:hidden"
					style={{ background: 'rgba(245, 241, 234, 0.95)' }}
				>
					<div
						className="flex flex-col gap-4 px-5 py-5 text-sm font-medium"
						style={{ color: '#292524' }}
					>
						<a href="#services" onClick={() => setOpen(false)}>
							Services
						</a>
						<a href="#work" onClick={() => setOpen(false)}>
							Our Work
						</a>
						<a href="#why" onClick={() => setOpen(false)}>
							About
						</a>
						<a href="#reviews" onClick={() => setOpen(false)}>
							Reviews
						</a>
						<a href="tel:+18175550199">Call (817) 555-0199</a>
					</div>
				</div>
			) : null}
		</header>
	)
}
